import Vue from "vue";
import VueRouter from "vue-router";
import TimeslotLandingPage from "@/components/website/TimeslotLandingPage";
import Enrollment from "@/views/timeslot/Enrollment";
import ResetPassword from "@/views/timeslot/ResetPassword";
import CustomerDashboard from "@/views/timeslot/customer/CustomerDashboard";
import CustomerMessages from "@/views/timeslot/customer/CustomerMessages";
import CustomerFeeds from "@/views/timeslot/customer/CustomerFeeds";
import CustomerBookings from "@/views/timeslot/customer/CustomerBookings";
import CustomerWallet from "@/views/timeslot/customer/CustomerWallet";
import CustomerSettings from "@/views/timeslot/customer/CustomerSettings";
import Discover from "@/views/timeslot/Discover";
import ProfessionalProfile from "@/views/timeslot/ProfessionalProfile";
import BecomeAProfessional from "@/views/timeslot/BecomeAProfessional";
import ProfessionalDashboard from "@/views/timeslot/professional/ProfessionalDashboard";
import ProfessionalMessages from "@/views/timeslot/professional/ProfessionalMessages";
import ProfessionalBookings from "@/views/timeslot/professional/ProfessionalBookings";
import ProfessionalAvailability from "@/views/timeslot/professional/ProfessionalAvailability";
import ProfessionalFeeds from "@/views/timeslot/professional/ProfessionalFeeds";
import ProfessionalWallet from "@/views/timeslot/professional/ProfessionalWallet";
import ProfessionalSettings from "@/views/timeslot/professional/ProfessionalSettings";
import CustomerSupport from "@/views/timeslot/customer/CustomerSupport";
import ProfessionalSupport from "@/views/timeslot/professional/ProfessionalSupport";
import CustomerProfile from "@/views/timeslot/customer/CustomerProfile";
import TimeslotLogin from "@/views/timeslot/enrollment/TimeslotLogin";
import TimeslotSignUp from "@/views/timeslot/enrollment/TimeslotSignUp";
import TimeslotOTP from "@/views/timeslot/enrollment/TimeslotOTP";
import TimeslotSuccessView from "@/views/timeslot/enrollment/TimeslotSuccessView";
import TimeslotResetPassword from "@/views/timeslot/reset/TimeslotResetPassword";
import TimeslotChangePassword from "@/views/timeslot/reset/TimeslotChangePassword";
import TimeslotResetOTP from "@/views/timeslot/reset/TimeslotResetOTP";
import TimeslotResetSuccessView from "@/views/timeslot/reset/TimeslotResetSuccessView";
import PaymentView from "@/views/timeslot/PaymentView";
import SuccessPage from "@/views/SuccessPage";
import ProfessionalSubscriptions from "@/views/timeslot/professional/ProfessionalSubscriptions";
import CustomerSubscriptions from "@/views/timeslot/customer/CustomerSubscriptions";
import CustomerNotifications from "@/views/timeslot/customer/CustomerNotifications";
import ProfessionalNotifications from "@/views/timeslot/professional/ProfessionalNotifications";
import TimeslotPassword from "@/views/timeslot/enrollment/TimeslotPassword";
import TimeslotReset from "@/views/timeslot/enrollment/TimeslotReset";
import TestView from "@/views/TestView";
import ProfessionalClasses from "@/views/timeslot/professional/ProfessionalClasses";
import CustomerClasses from "@/views/timeslot/customer/CustomerClasses";
import CreateClassPage from "@/views/CreateClassPage";
import TimeslotPreSignUp from "@/views/timeslot/enrollment/TimeslotPreSignUp";
import NewDiscover from "@/views/timeslot/NewDiscover";
import ProfessionalClassDetails from "@/views/timeslot/professional/ProfessionalClassDetails";
import SecondTestView from "@/views/SecondTestView";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landing-page",
    component: TimeslotLandingPage
  },
  {
    path: "/enrollment",
    name: "enrollment",
    component: TimeslotSignUp
  },
  {
    path: "/get-started",
    name: "timeslot-pre-sign-up",
    component: TimeslotPreSignUp
  },
  {
    path: "/login",
    name: "login",
    component: TimeslotLogin
  },
  // {
  //   path: "/sign-up",
  //   name: "signup",
  //   component: TimeslotSignUp
  // },
  {
    path: "/verify-email",
    name: "verify-email",
    component: TimeslotOTP
  },
  {
    path: "/success",
    name: "success",
    component: TimeslotSuccessView
  },
  {
    path: "/set-password",
    name: "set-password",
    component: TimeslotPassword
  },
  {
    path: "/new-password",
    name: "new-password",
    component: TimeslotReset
  },
  {
    path: "/reset",
    name: "reset",
    component: ResetPassword
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: TimeslotResetPassword
  },
  {
    path: "/change-password",
    name: "change-password",
    component: TimeslotChangePassword
  },
  {
    path: "/confirm-email",
    name: "confirm-email",
    component: TimeslotResetOTP
  },
  {
    path: "/reset-success",
    name: "reset-success",
    component: TimeslotResetSuccessView
  },
  {
    path: "/clients/:id",
    name: "customer-profile",
    component: CustomerProfile
  },

  {
    path: "/professionals/:id",
    name: "professional-profile",
    component: ProfessionalProfile
  },
  {
    path: "/client-dashboard",
    name: "customer-dashboard",
    component: CustomerDashboard
  },
  {
    path: "/customer-messages",
    name: "customer-messages",
    component: CustomerMessages
  },
  {
    path: "/customer-feeds",
    name: "customer-feeds",
    component: CustomerFeeds
  },
  {
    path: "/customer-bookings",
    name: "customer-bookings",
    component: CustomerBookings
  },
  {
    path: "/customer-wallet",
    name: "customer-wallet",
    component: CustomerWallet
  },
  {
    path: "/customer-settings",
    name: "customer-settings",
    component: CustomerSettings
  },
  {
    path: "/customer-classes",
    name: "customer-classes",
    component: CustomerClasses
  },
  {
    path: "/create-class",
    name: "create-class-page",
    component: CreateClassPage
  },
  {
    path: "/customer-support",
    name: "customer-support",
    component: CustomerSupport
  },
  {
    path: "/customer-notifications",
    name: "customer-notifications",
    component: CustomerNotifications
  },
  {
    path: "/professional-notifications",
    name: "professional-notifications",
    component: ProfessionalNotifications
  },
  {
    path: "/customer-subscriptions",
    name: "customer-subscriptions",
    component: CustomerSubscriptions
  },
  {
    path: "/discover-professionals",
    name: "discover",
    component: Discover
  },
  {
    path: "/become-a-professional",
    name: "become-a-professional",
    component: BecomeAProfessional
  },
  {
    path: "/professional-dashboard",
    name: "professional-dashboard",
    component: ProfessionalDashboard
  },
  {
    path: "/professional-messages",
    name: "professional-messages",
    component: ProfessionalMessages
  },
  {
    path: "/professional-bookings",
    name: "professional-bookings",
    component: ProfessionalBookings
  },
  {
    path: "/professional-availability",
    name: "professional-availability",
    component: ProfessionalAvailability
  },
  {
    path: "/professional-subscriptions",
    name: "professional-subscriptions",
    component: ProfessionalSubscriptions
  },
  {
    path: "/professional-feeds",
    name: "professional-feeds",
    component: ProfessionalFeeds
  },
  {
    path: "/wallet",
    name: "professional-wallet",
    component: ProfessionalWallet
  },
  {
    path: "/professional-settings",
    name: "professional-settings",
    component: ProfessionalSettings
  },
  {
    path: "/professional-support",
    name: "professional-support",
    component: ProfessionalSupport
  },
  {
    path: "/professional-classes",
    name: "professional-classes",
    component: ProfessionalClasses
  },
  {
    path: "/fund-wallet",
    name: "payment-view",
    component: PaymentView
  },
  {
    path: "/test-view",
    name: "test-view",
    component: TestView
  },
  {
    path: "/payment-successful",
    name: "success-page",
    component: SuccessPage
  },
  {
    path: "/professionals/:id/:professionalReference",
    name: "professional-reference",
    component: ProfessionalProfile
  },
  {
    path: "/discover",
    name: "new-discover",
    component: NewDiscover
  },

  {
    path: "/class-details/:id",
    name: "professional-class-details",
    component: ProfessionalClassDetails
  },
  {
    path: "/practice",
    name: "second-test-view",
    component: SecondTestView
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;

// const routew = [
//   { path: "/", name: "home", components: { content: Home } },
//   { path: "/one", name: 'one', components: {header: Header,
//       content : contentOne}, props: {header: true, content: false} },
//   { path: "/two", name: 'two', components: {header: Header, content: contentTwo}, props: {header: true, content: false} },
//   { path: "/three", name: 'three', components: {header: Header, content: contentThree}, props: {header: true, content: false} },
//   { path: "/four", name: 'four', components: {header: Header, content: contentFour}, props: {header: true, content: false} },
//   { path: "/five", name: 'five', components: {header: Header, content: contentFive}, props: {header: true, content: false} },
// ]
